import React from 'react';

const CartAddIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      role="presentation"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      {...props}
    >
      <g fill="currentcolor">
        <path d="M23.27 25.21H10.52L5.96 9.07H3.21V7.84h3.68l4.57 16.129h11.81zm0 0"></path>
        <path d="M23.27 22.469H10.219v-1.23H22.37l2.738-8.598-15.53-.52.042-1.242 17.168.582zm0 0M11.09 28.8a2.414 2.414 0 01-2.41-2.41 2.409 2.409 0 112.41 2.41zm0-3.59c-.649 0-1.18.528-1.18 1.18 0 .65.531 1.18 1.18 1.18.648 0 1.18-.53 1.18-1.18 0-.652-.54-1.18-1.18-1.18zm0 0M23.27 28.8a2.414 2.414 0 01-2.41-2.41 2.409 2.409 0 112.41 2.41zm0-3.59c-.649 0-1.18.528-1.18 1.18 0 .65.531 1.18 1.18 1.18a1.179 1.179 0 100-2.36zm0 0"></path>
        <path d="M12.652 11.695l1.23-.152 1.263 10.234-1.23.149zm0 0M18.188 21.785l1.054-10.015 1.235.132-1.059 10.012zm0 0"></path>
        <path d="M8.8 16.23h15.622v1.239H8.8zm0 0M24.371 3.68v-.008l1.23-.14zm0 0M23.21 11.078l-1.16-.418c.122-.34.24-.66.38-1.012.129-.328.261-.687.422-1.128l.046-.11.211-.582c.11-.308.22-.61.32-.887l.59.168.583.211c-.114.309-.223.621-.34.93-.082.219-.16.45-.25.672l-.14.36c-.11.288-.212.546-.302.788-.12.36-.242.668-.36 1.008zm0 0M17.852 11.89l-1.153-.46c.95-2.38 1.84-4.84 2.63-7.008l.03-.07c.082-.223.16-.454.262-.672l1.129.492c-.078.187-.16.387-.23.59l-.032.066c-.789 2.192-1.68 4.672-2.636 7.063zm0 0"></path>
        <path d="M23.55 7.121c-.64 0-1.421-.23-2.05-1.012l.96-.78c.68.85 1.528.491 1.56.472l.5 1.129c-.23.101-.579.191-.97.191zm0 0M22.71 9.48c-.64 0-1.42-.23-2.05-1.011l.961-.778c.66.809 1.48.508 1.57.47l.489 1.128c-.23.102-.57.191-.97.191zm0 0"></path>
        <path d="M24.602 7.32l-1.192-.332 1.04-3.777-.891-.652-1.778.5-1.222 1.41-.938-.809L21.09 1.97l2.719-.77 2.062 1.52zm0 0"></path>
      </g>
    </svg>
  );
};

export default CartAddIcon;
